/**
 * SGKE902A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SupplyresumptionResultregistrationConsumptiondeviceinfo {

    /**
     * 消費機器番号
     */
    consumptiondeviceNo?: string;
    /**
     * 設備番号
     */
    setsubiNo?: string;
    /**
     * 消費機器機種
     */
    consumptiondeviceModel?: string;
    /**
     * 消費機器機種名
     */
    consumptiondeviceModelname?: string;
    /**
     * 製造年月
     */
    manufactureYm?: string;
    /**
     * 給排気方式
     */
    ventilationHoshiki?: string;
    /**
     * 給排気方式名
     */
    ventilationHoshikiMei?: string;
    /**
     * 接続状況
     */
    cnnctJokyo?: string;
    /**
     * 接続状況名
     */
    cnnctJokyoMei?: string;
    /**
     * 販売形態
     */
    saleKeitai?: string;
    /**
     * 販売形態名
     */
    saleKeitaiMei?: string;
    /**
     * メーカー
     */
    manufacturer?: string;
    /**
     * メーカー名
     */
    manufacturerMei?: string;
    /**
     * 型式
     */
    model?: string;
    /**
     * 設置場所
     */
    installationPlace?: string;
    /**
     * 設置場所名
     */
    installationlocationMei?: string;
    /**
     * 不適合コード
     */
    nonconformityCode?: string;
    /**
     * 不適合内容
     */
    nonconformityCont?: string;
    /**
     * CO値
     */
    covalue?: string;
    /**
     * CO値名
     */
    covalueMei?: string;
}

